window.addEventListener('load', function() {
    var sections = document.querySelectorAll('.shopify-section:not(.shopify-section-group-footer-group)');
    sections.forEach(function(section) {
        if (section.id === 'shopify-section-halo-toolbar-mobile') {
            return;
        }
      
        var elementTop = section.getBoundingClientRect().top;
        var viewportBottom = window.innerHeight;

        // Verifica se o topo do elemento está fora do viewport
        if (elementTop >= viewportBottom) {
            section.setAttribute('data-aos', 'fade-up');
            //section.setAttribute('data-aos-anchor-placement', 'center-bottom');
        }
    });

    AOS.init();
});

// Nesletter Trigger

$('[trigger-newsletter]').on('click', function(){
  setTimeout(function() {
      document.body.classList.add('newsletter-show');
  }, 0);
  
  setTimeout(() => {
      document.body.classList.add('show-newsletter-image');
  }, 700)
})


// UPSELL Carrinho
window.upsellSliderInit = function(){
  var upsellCartSlider = new Swiper(".recommend-slider", {
    slidesPerView: "auto",
    spaceBetween: 15,
    slidesPerGroup: 3,
    freeMode: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true
    }
  });
}

function beforeSend() {
  $('#dropdown-cart').addClass('updating-cart');
}

function afterSend() {
  $('#dropdown-cart').removeClass('updating-cart');
}

$(document).on('submit', '.upsell-form', function(e) {
  e.preventDefault();

  const formData = new FormData(this);
  const serializedData = {};
  formData.forEach((value, key) => {
    serializedData[key] = value;
  });
  const jsonData = JSON.stringify(serializedData);

  // URL da API da Shopify para adicionar um item ao carrinho
  const addToCartUrl = window.Shopify.routes.root + 'cart/add.js';

  // Opções da requisição
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: jsonData,
  };

  beforeSend(); // Ação "before send" antes da requisição

  // Faz a requisição usando fetch com ação "before send" e "after send"
  fetch(addToCartUrl, requestOptions)
    .then((response) => {
      afterSend(); // Ação "after send" após a conclusão da requisição

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => {
      // A requisição foi bem-sucedida, você pode atualizar o carrinho ou fazer outras ações necessárias aqui
      window.updateCart();
    })
    .catch((error) => {
      // Houve um erro na requisição, você pode tratar o erro aqui
      console.error('Error:', error);
    });
});

$(document).on('change', '.variants-product-selects select', function() {
  var $currentSelect = $(this);
  var $nextSelect = $currentSelect.closest('.variants-product-selects').find('select').eq($currentSelect.index() + 1);
  
  if ($nextSelect.length && $nextSelect.is(':hidden')) {
      $nextSelect.show();
  } else if (!$nextSelect.length) {
      var selectedOptions = $currentSelect.closest('.variants-product-selects').find('select').map(function() { return $(this).val(); }).get();
      var productData = JSON.parse($currentSelect.closest('.infoProduct').find('[data-json-product]').text());
      
      var matchingVariant = productData.find(function(variant) {
          return selectedOptions.every(function(option, index) {
              return variant.options[index] === option;
          });
      });

      if (matchingVariant && matchingVariant.available) {
          $currentSelect.closest('.infoProduct').find('.variantIdAddCart').val(matchingVariant.id);
          $currentSelect.closest('.infoProduct').find('.recommend-btn-add').prop('disabled', false);
          $currentSelect.closest('.infoProduct').find('.recommend-btn-add').val('ADICIONAR');
      } else {
          $currentSelect.closest('.infoProduct').find('.recommend-btn-add').prop('disabled', true);
          $currentSelect.closest('.infoProduct').find('.recommend-btn-add').val('ESGOTADO');
          console.log('Produto esgotado');
      }
  }

  var container = $('.halo-cart-sidebar').find('.previewCart');
  var scrollTo = $('.halo-cart-sidebar').find('.recommend-container');
  
  // A posição de rolagem final é a posição do topo do .recommend-container mais sua altura
  var scrollPosition = scrollTo.offset().top + scrollTo.outerHeight() + container.scrollTop() - container.position().top;
  
  // Realiza a rolagem
  container.animate({
      scrollTop: scrollPosition
  }, 1000); // 1000 milissegundos para a animação de rolagem
});